import { motion } from "framer-motion";
import { BookOpenCheck } from "lucide-react";
import MotionSection from "../common/MotionSection";
import SectionHeading from "../common/SectionHeading";

function CountryCoursesSection({ country }) {
  return (
    <MotionSection className="py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-6">
        <SectionHeading
          kicker="Popular Courses"
          title="Programs Students Commonly Choose"
          description="Choose a pathway that aligns with your strengths, long-term goals, and global career ambitions."
        />

        <div className="mt-10 grid gap-5 md:grid-cols-2 xl:grid-cols-3">
          {country.courses.map((course) => (
            <motion.article
              key={course.name}
              whileHover={{ y: -6 }}
              transition={{ duration: 0.25, ease: "easeOut" }}
              className="group signature-card signature-card-interactive rounded-2xl p-6"
            >
              <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-sky-glow text-royal-blue transition-colors group-hover:bg-royal-blue group-hover:text-soft-white">
                <BookOpenCheck className="h-5 w-5" aria-hidden="true" />
              </span>
              <h3 className="mt-4 text-2xl leading-tight">{course.name}</h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-text/80">{course.text}</p>
            </motion.article>
          ))}
        </div>
      </div>
    </MotionSection>
  );
}

export default CountryCoursesSection;
